import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/normal/cdf';
import __var_2__ from '@stdlib/stats/base/dists/normal/ctor';
import __var_3__ from '@stdlib/stats/base/dists/normal/entropy';
import __var_4__ from '@stdlib/stats/base/dists/normal/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/normal/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/normal/mean';
import __var_7__ from '@stdlib/stats/base/dists/normal/median';
import __var_8__ from '@stdlib/stats/base/dists/normal/mgf';
import __var_9__ from '@stdlib/stats/base/dists/normal/mode';
import __var_10__ from '@stdlib/stats/base/dists/normal/pdf';
import __var_11__ from '@stdlib/stats/base/dists/normal/quantile';
import __var_12__ from '@stdlib/stats/base/dists/normal/skewness';
import __var_13__ from '@stdlib/stats/base/dists/normal/stdev';
import __var_14__ from '@stdlib/stats/base/dists/normal/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace normal
*/
var normal = {};

/**
* @name cdf
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/cdf}
*/
setReadOnly( normal, 'cdf', __var_1__);

/**
* @name Normal
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/ctor}
*/
setReadOnly( normal, 'Normal', __var_2__);

/**
* @name entropy
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/entropy}
*/
setReadOnly( normal, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/kurtosis}
*/
setReadOnly( normal, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/logpdf}
*/
setReadOnly( normal, 'logpdf', __var_5__);

/**
* @name mean
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/mean}
*/
setReadOnly( normal, 'mean', __var_6__);

/**
* @name median
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/median}
*/
setReadOnly( normal, 'median', __var_7__);

/**
* @name mgf
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/mgf}
*/
setReadOnly( normal, 'mgf', __var_8__);

/**
* @name mode
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/mode}
*/
setReadOnly( normal, 'mode', __var_9__);

/**
* @name pdf
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/pdf}
*/
setReadOnly( normal, 'pdf', __var_10__);

/**
* @name quantile
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/quantile}
*/
setReadOnly( normal, 'quantile', __var_11__);

/**
* @name skewness
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/skewness}
*/
setReadOnly( normal, 'skewness', __var_12__);

/**
* @name stdev
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/stdev}
*/
setReadOnly( normal, 'stdev', __var_13__);

/**
* @name variance
* @memberof normal
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/normal/variance}
*/
setReadOnly( normal, 'variance', __var_14__);


// EXPORTS //
export default normal;

export { __var_1__ as cdf, __var_2__ as Normal, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as median, __var_8__ as mgf, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};